module.exports = __webpack_public_path__ + "static/pwb1-7631db4c9fb5118f218ef16451470173.jpg";